<template>
    <div>
        <span class="me-1">{{ trans('activity.asset.usage-category.changed.label') }}</span>
        <template v-if="oldKey">
            <span class="text-muted line-through">{{ trans(oldKey) }}</span>
            <span> → </span>
        </template>
        <span class="font-semibold">{{ trans(newKey) }}</span>
    </div>
</template>
<script setup>
import { computed } from 'vue';
import { trans } from '@/mixins/i18n.js';

const props = defineProps({ item: { type: Object, required: true } });

const oldKey = computed(() => props.item.properties?.old?.label || null);
const newKey = computed(() => props.item.properties?.new?.label || 'general.not_available');
</script>
